module.exports = __webpack_public_path__ + "img/开发商介绍_image.8e04238b.png";